import request from '../../utils/request'
import deepCopy from '../../utils/deepCopy'
import objSort from '../../utils/objSort'
import intl from 'react-intl-universal'
import { Toast } from 'antd-mobile'
import {
  isObjEmpty,
  getEnAbleCancelMealTypes,
  getOssImg,
  getDateStr
} from '../Order/OrderFunction'

// 获取订单状态, 用于在订单详情页面显示
export function guID () {
  return Number(Math.random().toString().substr(3, 8) + Date.now()).toString(36)
}
export function getOrderStatus (orderId, setOrderStatus, Language, setShowModal, setModalInfo, setSubscribe) {
  request(`/v1/order?orderID=${orderId}`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (res.error) {
      setShowModal(true)
      setModalInfo(res.message)
    } else {
      // console.log(res.data)
      if (res.data && res.data.length > 0) {
        setOrderStatus(res.data[0].orderStatus)
        if (res.data[0].orderStatus !== 1) {
          setSubscribe(true) // 设置为true代表不显示小圆圈
        }
      }
    }
  }).catch((error) => {
    console.log(error)
  })
}
/** **************************************** */
/** *****历史订单页面获取所有订单列表*********** */
/** **************************************** */
export function getOrderData (Language, setShowModal, setModalInfo, setOrderListData, setShowInfo) {
  request(`/v1/order`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (!res.error) {
      // console.log(res.data)
      const orderData = deepCopy(res.data)
      // console.log(orderData)
      const tmpOrderList = []
      orderData.forEach(item => {
        const date = item.creation_date ? item.creation_date.substr(0, 19).replace(/[T]/, ' ').replace(/[-]/g, '/') : ''
        const tmpDate = new Date(date)
        const dateToTime = -tmpDate.getTime()
        const foodName = item.foodNames ? item.foodNames.slice(0, -1).replace(/[,]/g, '、') : ''
        let totalPrice = 0
        item.orderdetails.forEach(detailItem => {
          totalPrice += detailItem.count * detailItem.foodUnitPrice
        })
        totalPrice = Math.round(parseFloat(totalPrice * 100)) / 100
        const tmpOrderItem = {
          id: item.id,
          patPositionName: item.patPositionName,
          orderStatus: item.orderStatus,
          creation_date: date,
          foodNames: foodName,
          weChartPayPrice: Math.round(parseFloat(item.totalPrice * 100)) / 100,
          totalPrice: totalPrice,
          dateToTime: dateToTime
        }
        tmpOrderList.push(tmpOrderItem)
      })
      if (orderData.length === 0) {
        setShowInfo(true)
      }
      tmpOrderList.length > 0 && tmpOrderList.sort(objSort('dateToTime'))
      // console.log(tmpOrderList)
      setOrderListData(tmpOrderList)
    } else {
      setModalInfo(intl.get('Failed to get order list.'))
      setShowModal(true)
    }
  }).catch((error) => {
    console.log(error)
  })
}

/** **************************************** */
/** *****历史订单详情页面获取所有详细餐次所点食物列表*********** */
/** **************************************** */
export function getOrderDetail (OrderMark, Language, setShowModal, setModalInfo, orderId, setOrderDetailList, setDateArr, flag = '', checkList = [], setCheckList) {
  request(`/v1/order/details/${orderId}`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (!res.error) {
      // console.log(checkList)
      const orderdetail = deepCopy(res.data) || []
      // console.log(orderdetail)
      if (orderdetail.length > 0) {
        let refundStatus = true
        let cancelStatus = true
        const tmpOrderDetail = orderdetail.map(item => {
          item.order = true
          item.tmpOrder = true
          item.tmpPayStatus = item.payStatus
          item.uniqueID = guID()
          item.picAddress = ''
          if (flag === 'checkRefund' && checkList.includes(item.id) && item.payStatus !== 4) {
            refundStatus = false
          } else if (flag === 'checkCancel' && item.payStatus !== 2) {
            cancelStatus = false
          }
          return item
        })
        if (flag === 'checkRefund' && refundStatus) {
          setShowModal(true)
          setModalInfo(intl.get('Refund successfully.'))
          setCheckList([])
        } else if (flag === 'checkCancel' && cancelStatus) {
          setShowModal(true)
          setModalInfo(intl.get('Order cancelled successfully.'))
        }
        // console.log(tmpOrderDetail)
        updateOrderDetailDate(orderdetail, setDateArr)
        // console.log('获取详情页食物图片')
        getOssImg(OrderMark, tmpOrderDetail, Language, setOrderDetailList)
        // setOrderDetailList(tmpOrderDetail)
      }
    } else {

    }
  }).catch((error) => {
    console.log(error)
  })
}
// 当根据id查到了订单详情，读取订单的详情、更新一下日期并且排序。
export function updateOrderDetailDate (orderdetail, setDateArr) {
  const newDateArr = []
  orderdetail.forEach(item => {
    // console.log(item)
    if (item.takeFoodTime) {
      const dateItem = parseInt(item.takeFoodTime.substr(0, 10).replace(/[-]/g, ''))
      const indexNum = newDateArr.indexOf(dateItem)
      if (indexNum < 0 && item.selectedQuantity !== 0) {
        newDateArr.push(dateItem)
      }
    }
  })
  newDateArr.length > 0 && newDateArr.sort((a, b) => a - b)
  const tmp = newDateArr.map(item => {
    const strItem = String(item)
    return strItem.substr(0, 4) + '-' + strItem.substr(4, 2) + '-' + strItem.substr(6, 2)
  })
  setDateArr(tmp)
  return tmp
}
// 点击确认退餐触发事件
export function handleComfirmCancelOrder (orderDetailList, OrderMark, orderStatus, cancelNum, setShowModal, setModalInfo, setTabDisplay, advanceDay) {
  if (cancelNum === 0) {
    setShowModal(true)
    setModalInfo(intl.get('You have not chosen any dishes yet.'))
    return false
  }
  if (orderStatus === 0) { // 未付款状态
    setShowModal(true)
    setModalInfo(intl.get('You have not paid yet.'))
    return false
  } else if (orderStatus === 1) { // 已付款状态
    if (orderDetailList.length > 0) {
      let flag = true
      const tmpCancelMeals = orderDetailList.filter(item => {
        return item.tmpOrder === false
      })
      if (tmpCancelMeals.length > 0) {
        console.log(tmpCancelMeals)
        const date = getDateStr(advanceDay) // 获取今天+advanceDay的日期
        const enAbleCancelMealtypes = getEnAbleCancelMealTypes(OrderMark)
        // console.log(getEnAbleCancelMealTypes(OrderMark))
        tmpCancelMeals.map(itemData => {
          if (itemData.payStatus === 0 || itemData.payStatus === 2) {
            // 单个餐次没有付钱的情况
            setShowModal(true)
            setModalInfo(intl.get('You have not paid yet.'))
            flag = false
          } else if (itemData.payStatus === 1) {
            if (!isObjEmpty(OrderMark.properties)) {
              if ((itemData.isPotFood === 1 && OrderMark.properties.isFoodGang && OrderMark.properties.isCombinationFoodWriteHis) || (itemData.isPotFood === 0 && OrderMark.properties.isPotFoodWriteHis)) {
                // 当这个餐次已经付款，而且营养餐包伙制且写入his  或者   小锅菜写入his的时候
                setShowModal(true)
                setModalInfo(intl.get('The dishes settled after discharge are not allowed to be returned.'))
                flag = false
              } else { // 当这个餐次没有写入his的时候，检查是否超过退餐截止时间
                if (itemData.takeFoodTime) {
                  if (Number(itemData.takeFoodTime.substr(0, 10).replace(/[-]/g, '')) < Number(date.replace(/[/]/g, '')) ||
                  (itemData.takeFoodTime.substr(0, 10).replace(/[-]/g, '') === date.replace(/[/]/g, '') && !enAbleCancelMealtypes.includes(itemData.mealTypeID))) {
                    setShowModal(true)
                    setModalInfo(intl.get('Some dishes exceeded the Unsubscribe deadline.'))
                    flag = false
                  }
                }
              }
            }
          } else if (itemData.payStatus === 3) {
            setShowModal(true)
            setModalInfo(intl.get('Some dishes are being refunded.'))
            flag = false
          } else if (itemData.payStatus === 4) {
            setShowModal(true)
            setModalInfo(intl.get('No duplicate refund is allowed for dishes that have been refunded.'))
            flag = false
          } else if (itemData.payStatus === 5) {
            setShowModal(true)
            setModalInfo(intl.get('No refund is allowed for completed dishes.'))
            flag = false
          }
        })
      } else {
        setShowModal(true)
        setModalInfo(intl.get('You have not chosen any dishes yet.'))
        flag = false
      }
      if (flag === false) {
        return flag
      } else {
        setTabDisplay(true)
      }
    }
  } else if (orderStatus === 2) { // 订单已完成状态
    setShowModal(true)
    setModalInfo(intl.get('The order has been completed and no refund is allowed.'))
    return false
  } else { // 状态的参数为null或者是一个之前没有约定的值
    setShowModal(true)
    setModalInfo('未知的订单状态')
    return false
  }
}
// 如果之前的确认退餐handleComfirmCancelOrder校验通过了，可以退餐，那么点击确认，则进行退餐操作
export function refundOrder (orderDetailList, setOrderDetailList, orderId, Language, setShowModal, setModalInfo, checkList, setCheckList, setFlag) {
  const tmpDataObj = {}
  const tmpDetailIDs = []
  const tmpOrderID = orderId
  const tmpOrderDetailList = orderDetailList.map(item => {
    // console.log(item)
    if (item.tmpOrder === false) {
      tmpDetailIDs.push(item.id)
      item.tmpPayStatus = 3
    }
    item.tmpOrder = true
    return item
  })
  // console.log(tmpOrderDetailList)
  setOrderDetailList(tmpOrderDetailList)
  tmpDataObj.detailIDs = tmpDetailIDs
  tmpDataObj.orderID = tmpOrderID
  // console.log(tmpDataObj)
  setCheckList([...checkList, ...tmpDetailIDs])
  Toast.loading(intl.get('Refunding...'), 4, null, false)
  request(`/v1/order/refund`, {
    method: 'POST',
    headers: {
      'Accept-Language': Language.acceptLanguage
    },
    body: tmpDataObj
  }).then((res) => {
    if (res.error) {
      setShowModal(true)
      setModalInfo(res.message)
    } else {
      // setShowModal(false)
      setFlag('checkRefund')
    }
  }).catch((error) => {
    console.log(error)
  })
}
// 未付款状态点击支付重新调用支付接口
export function rePayByOrderID (payBottonRef, orderId, Language, setShowModal, setModalInfo, history) {
  payBottonRef.current.disabled = true
  // console.log(orderId)
  request(`/v1/order/repay?orderId=${orderId}`, {
    method: 'POST',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (res.error) {
      payBottonRef.current.disabled = false
      let tmpMessage = res.message
      switch (res.code) {
        case '1001': tmpMessage = intl.get('Subscriber does not exist.'); break // 订餐人不存在
        case '1002': tmpMessage = intl.get('The hospital does not exist.'); break // 医院不存在
        case '1003': tmpMessage = intl.get('The order is invalid.'); break // 订单无效
        case '1004': tmpMessage = intl.get('This order has been cancelled.'); break // 订单已取消
        case '1005': window.location.reload(); break // 订单状态不是待付款
        case '1006': tmpMessage = intl.get('Invalid order details.'); break // 订单详情无效
        case '1007': tmpMessage = intl.get('No payment is required for this order.'); break // 订单不需要付款
        case '1008': tmpMessage = intl.get('Failed to get payment address.'); break // 获取付款地址失败
      }
      setShowModal(true)
      setModalInfo(tmpMessage)
    } else {
      // console.log(res)
      if (res.data === '0') {
        history.push('/historicalOrders')
      } else {
        const tmpurl = res.data
        if (res.data !== '') {
          const url = encodeURI(tmpurl).replace('#', '%23')
          window.location.href = url
        }
      }
    }
  }).catch((error) => {
    console.log(error)
  })
}
export function cancelByOrderID (cancelBottonRef, orderId, Language, setShowModal, setModalInfo, setFlag) {
  cancelBottonRef.current.disabled = true
  // console.log(orderId)
  Toast.loading(intl.get('Canceling...'), 5.5, null, false)
  request(`/v1/order/cancel?orderId=${orderId}`, {
    method: 'POST',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (res.error) {
      cancelBottonRef.current.disabled = false
      const tmpMessage = res.message
      setShowModal(true)
      setModalInfo(tmpMessage)
    } else {
      setFlag('checkCancel')
    }
  }).catch((error) => {
    console.log(error)
  })
}
